<script setup lang="ts">
import type { OrderLineItem as OrderLineItemType } from "@shopware-pwa/types";
import ProductImage from "~/templates/elements/ProductImage.vue";

export interface OrderProductImageProps {
  lineItem?: OrderLineItemType;
}

const { lineItem } = defineProps<OrderProductImageProps>();

/*
 lookup the first item that is not supposed to be hidden
 */
const visibleLineItem = computed(() => {
  if (lineItem?.extensions?.brita_eshop_set_hide_main_product_image?.value) {
    // if main image should be hidden show the first child that is not a hidden product
    return lineItem?.children?.find(
      (child, index) => index > 0 && !child?.customFields?.eshopSet?.eshopSetProductIsHidden,
    )?.cover;
  }

  return lineItem?.cover ?? lineItem?.children?.[0]?.cover;
});
</script>

<template>
  <ProductImage
    :product-media="visibleLineItem"
    :product-name="lineItem?.label"
    fallback-class="product-image flex-shrink-0 w-20 object-contain object-center aspect-[74/100] rounded-lg bg-light-grey p-2"
    main-class="product-image w-20 flex-shrink-0 object-contain object-center aspect-[74/100] rounded-lg bg-light-grey"
    src-set-until="800"
  />
</template>
